<template>
  <v-row no-gutters justify="start">
    <v-text-field
      id="search-input"
      outlined
      hide-details
      single-line
      dense
      label="Поиск"
      prepend-inner-icon="search"
      append-icon="more_horiz"
      @click:append="filterHandler"
      v-model="search"
      @keyup.enter="searchHandler"
    />
    <v-btn
      text
      color="primary"
      class="text-capitalize"
      v-if="isClear"
      @click.prevent="clearHandler($router.history.current.name)"
    >
      Очистить поиск
    </v-btn>
  </v-row>
</template>

<script>
export default {
  name: 'Search',
  data: () => ({
    search: '',
    isClear: false,
    enum: { SUBSCRIBERS: 'subscribers', REGISTRARS: 'registrars' }
  }),
  computed: {
    searchValue() {
      return this.$store.state.subscribers.searchValue
    },
    page() {
      return this.$store.state.subscribers.page
    }
  },
  methods: {
    searchHandler() {
      this.setSearchRequest(this.$router.history.current.name)
    },
    async getListRequest(dispatchKey) {
      await this.$store.commit('SET_PAGE_NUMBER', 1)
      await this.$store.commit('SET_SEARCH_VALUE', '')
      await this.$store.dispatch(`${dispatchKey}`, {
        amount: 10,
        page: this.page
      })
      this.isClear = false
      this.search = ''
    },
    async clearHandler(key) {
      switch (key) {
        case this.enum.REGISTRARS:
          this.getListRequest('GET_OPERATORS_LIST')
          break
        case this.enum.SUBSCRIBERS:
          this.getListRequest('GET_SUBSCRIBERS_LIST')
          break
      }
    },
    async getSearchRequest(dispatchName) {
      await this.$store.commit('SET_SEARCH_VALUE', this.search)
      await this.$store.dispatch(`${dispatchName}`, {
        innFilter: this.searchValue,
        nameFilter: this.searchValue,
        amount: 10,
        page: 1
      })
      this.isClear = true
    },
    setSearchRequest(key) {
      switch (key) {
        case this.enum.REGISTRARS:
          this.getSearchRequest('GET_OPERATORS_LIST')
          break
        case this.enum.SUBSCRIBERS:
          this.getSearchRequest('GET_SUBSCRIBERS_LIST')
          break
      }
    },
    filterHandler() {}
  }
}
</script>

<style lang="scss" scoped>
.v-input {
  width: 380px;
}
.v-btn {
  transform: translateY(2px);
}
</style>
